var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointRedeemed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3305_32804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.26172 11.0214V15.9914C4.26172 17.8114 4.26172 17.8114 5.98172 18.9714L10.7117 21.7014C11.4217 22.1114 12.5817 22.1114 13.2917 21.7014L18.0217 18.9714C19.7417 17.8114 19.7417 17.8114 19.7417 15.9914V11.0214C19.7417 9.20141 19.7417 9.20141 18.0217 8.04141L13.2917 5.31141C12.5817 4.90141 11.4217 4.90141 10.7117 5.31141L5.98172 8.04141C4.26172 9.20141 4.26172 9.20141 4.26172 11.0214Z",
    stroke: "#E02126",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.63V5C17.5 3 16.5 2 14.5 2H9.5C7.5 2 6.5 3 6.5 5V7.56",
    stroke: "#E02126",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6317 10.9909L13.2017 11.8809C13.2917 12.0209 13.4917 12.1609 13.6417 12.2009L14.6617 12.4609C15.2917 12.6209 15.4617 13.1609 15.0517 13.6609L14.3817 14.4709C14.2817 14.6009 14.2017 14.8309 14.2117 14.9909L14.2717 16.0409C14.3117 16.6909 13.8517 17.0209 13.2517 16.7809L12.2717 16.3909C12.1217 16.3309 11.8717 16.3309 11.7217 16.3909L10.7417 16.7809C10.1417 17.0209 9.68173 16.6809 9.72173 16.0409L9.78173 14.9909C9.79173 14.8309 9.71173 14.5909 9.61173 14.4709L8.94173 13.6609C8.53173 13.1609 8.70173 12.6209 9.33173 12.4609L10.3517 12.2009C10.5117 12.1609 10.7117 12.0109 10.7917 11.8809L11.3617 10.9909C11.7217 10.4509 12.2817 10.4509 12.6317 10.9909Z",
    stroke: "#E02126",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3305_32804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointRedeemed);
export default __webpack_public_path__ + "static/media/point-redeemed.ca27b7dd2a4301d7900938232222f654.svg";
export { ForwardRef as ReactComponent };